import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { REACT_APP_FCM_VAPID_KEY } from "environment";
import { getFirebaseConfig, getWebPushPublicVapidKeyFromConfig } from "config/firebaseConfig";

/** Single Firebase app instance (avoids duplicate initializeApp in HMR). */
export const firebaseApp = getApps().length ? getApp() : initializeApp(getFirebaseConfig());

const envVapid = (REACT_APP_FCM_VAPID_KEY && String(REACT_APP_FCM_VAPID_KEY).trim()) || "";

/**
 * Web Push VAPID *public* key — must belong to the same Firebase project as {@link getFirebaseConfig}.
 * Prefer `webPushPublicVapidKey` in `config/firebase.web.json` per env; override with REACT_APP_FCM_VAPID_KEY.
 */
export const FCM_VAPID_KEY = envVapid || getWebPushPublicVapidKeyFromConfig();

let messagingInstance = null;

/** Lazy singleton — call only after {@link isSupported} resolves true. */
export function getMessagingInstance() {
  if (!messagingInstance) {
    messagingInstance = getMessaging(firebaseApp);
  }
  return messagingInstance;
}
